import { create } from 'zustand'
import type { Progress, SessionRecord } from '@/domain/session'
import { emptyProgress } from '@/domain/session'
import { progressRepository } from '@/services/progressRepository'

interface ProgressStore {
  progress: Progress
  loaded: boolean
  load: (challengeId: string) => Promise<void>
  addSession: (record: Omit<SessionRecord, 'id'>) => Promise<SessionRecord>
  replaceAll: (progress: Progress) => Promise<void>
  reset: () => Promise<void>
}

const newId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `s-${Date.now()}-${Math.round(Math.random() * 1e6)}`

export const useProgressStore = create<ProgressStore>((set, get) => ({
  progress: emptyProgress(''),
  loaded: false,

  load: async (challengeId) => {
    const progress = await progressRepository.load(challengeId)
    set({ progress, loaded: true })
  },

  addSession: async (record) => {
    const saved: SessionRecord = { ...record, id: newId() }
    const progress: Progress = {
      challengeId: get().progress.challengeId || record.challengeId,
      sessions: [...get().progress.sessions, saved],
    }
    set({ progress })
    await progressRepository.save(progress)
    return saved
  },

  replaceAll: async (progress) => {
    set({ progress })
    await progressRepository.save(progress)
  },

  reset: async () => {
    const progress = emptyProgress(get().progress.challengeId)
    set({ progress })
    await progressRepository.save(progress)
  },
}))
